/**
 * Main layout wrapper with navigation
 */

import React, { ReactNode } from 'react';
import MenuBar from '../components/MenuBar';
import './MainLayout.css';
import backgroundImage from '../assets/globe-background.jpg';

interface MainLayoutProps {
    children: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
    return (
        <div className="mainLayoutWrapper">
            <div
                className="mainLayoutBackground"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            />
            <div className="mainLayoutContent">
                <MenuBar />
                <div className="spacer" />
                {children}
            </div>
        </div>
    );
}
